import {locales}from'@bells/i18n/runtime';import {z}from'zod';const i=z.object({language:z.enum(locales).optional()});export{i as VerificationRequestSchema};